// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';


export interface ActionGetUrlSetupAPI extends Action {
    dealerId: string
}


export const getUrlSetupAPI = (dealerId: string): ActionGetUrlSetupAPI => ({
    type: ACTIONS.GET_URLSETUP_API_REQUEST,
    dealerId
});
;


export interface ActionGetUrlSetupAPISuccess extends Action {
    url: string
}

export const getUrlSetupAPISuccess = (url: string): ActionGetUrlSetupAPISuccess => ({
    type: ACTIONS.GET_URLSETUP_API_SUCCESS,
    url
});

export const getUrlSetupAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_URLSETUP_API_ERROR,
    error
});




